import { NgModule } from '@angular/core';
import { NonconformitiesListComponent } from './nonconformities-list.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RequiredClaimDirective } from '@ews/users-management';
import { IonicModule } from '@ionic/angular';
import { DesignSystemModule } from '@bcl/design-system';

@NgModule({
  declarations: [NonconformitiesListComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RequiredClaimDirective,
    DesignSystemModule,
    IonicModule,
  ],
  exports: [NonconformitiesListComponent],
})
export class NonconformitiesListModule {}
